import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSEmploymentData, type EnrollmentHYCSEmploymentSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSEmploymentDataMock: EnrollmentHYCSEmploymentData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/employment',
  enrollmentData: {
    applicationId: '12423478',
  },
}

export const submitEnrollmentHYCSEmploymentDataMock: EnrollmentHYCSEmploymentSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/finances',
}

export const mockGetEnrollmentHYCSEmploymentData = graphql.mutation('getEnrollmentHYCSEmploymentData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSEmploymentDataMock } })
})

export const mockSubmitEnrollmentHYCSEmploymentData = graphql.mutation('submitEnrollmentHYCSEmploymentData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSEmploymentDataMock } })
})

export const mockEnrollmentHYCSEmployment = [
  mockGetEnrollmentHYCSEmploymentData,
  mockSubmitEnrollmentHYCSEmploymentData,
]
